import React from 'react';
import Icon from './ui/Icon';
import Reveal, { RevealGroup } from './ui/Reveal';
import SectionLabel from './ui/SectionLabel';
import { watch } from '../data/content';

/**
 * "Watch the Story Happen" — the brief's invitation to follow the ministry
 * while it is still being built. The repeated "Watch …" of the original is
 * kept, since the repetition is the point.
 */
export default function WatchStory() {
  return (
    <section id="watch" className="bg-cream-200 py-24 sm:py-32">
      <div className="shell grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal variant="fade">
            <SectionLabel index="06">Watch Us Grow</SectionLabel>
          </Reveal>

          <Reveal
            as="h2"
            delay={80}
            className="mt-7 font-display text-[2rem] font-semibold uppercase leading-[1.06] tracking-[0.01em] text-ink sm:text-4xl lg:text-[3rem]"
          >
            {watch.title}
          </Reveal>
          <Reveal variant="rule" delay={240} className="rule mt-6" />

          <Reveal as="p" delay={300} className="mt-8 text-[0.98rem] leading-relaxed text-ink/75">
            {watch.lead}
          </Reveal>
          <Reveal
            as="p"
            delay={360}
            className="mt-5 font-display text-xl uppercase leading-snug tracking-[0.06em] text-ink sm:text-2xl"
          >
            {watch.invite}
          </Reveal>

          <RevealGroup as="ul" variant="left" stagger={90} delay={120} className="mt-8 space-y-2">
            {watch.honest.map((line) => (
              <li key={line} className="text-[0.98rem] leading-relaxed text-ink/70">
                {line}
              </li>
            ))}
          </RevealGroup>

          <Reveal
            delay={200}
            className="mt-8 border-l-2 border-gold pl-5 font-serif text-lg italic leading-relaxed text-ink sm:text-xl"
          >
            {watch.promise}
          </Reveal>
        </div>

        <div>
          <Reveal as="p" variant="fade" className="text-[0.7rem] uppercase tracking-[0.3em] text-ink/60">
            {watch.instead}
          </Reveal>

          <RevealGroup
            as="ul"
            variant="left"
            stagger={80}
            delay={120}
            className="mt-7 divide-y divide-ink/10 border-y border-ink/10"
          >
            {watch.items.map((item) => (
              <li key={item} className="group flex items-center gap-4 py-4 transition-colors duration-300">
                <Icon
                  name="check"
                  className="h-4 w-4 shrink-0 text-gold transition-transform duration-500 ease-out-expo group-hover:translate-x-1"
                  strokeWidth={2.4}
                />
                <span className="text-[0.98rem] leading-snug text-ink/80">
                  <span className="font-display uppercase tracking-[0.1em] text-gold-700">Watch</span> {item}.
                </span>
              </li>
            ))}
          </RevealGroup>

          <Reveal as="p" delay={200} className="mt-8 text-[0.98rem] leading-relaxed text-ink/75">
            {watch.close}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
